var React = require('react');

function LocationDropPinInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"d":"M32 61s20-24.152 20-38.772C52 11.608 43.046 3 32 3s-20 8.609-20 19.228C12 36.848 32 61 32 61z","key":0}),React.createElement("path",{"d":"M32 29a6 6 0 1 0 0-12 6 6 0 0 0 0 12z","key":1})]));
}

LocationDropPinInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = LocationDropPinInline;

LocationDropPinInline.default = LocationDropPinInline;
